export default (): void => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(function ($dom) {
    const doc = $dom[0]

    unsubscribers.forEach((unsubscriber) => unsubscriber())

    const eventDrivenPrepareTabs = doc.querySelectorAll<HTMLAnchorElement>(
      "[data-behaviour='event-driven-prepare-tab']"
    )

    function updatePrepareTabUrl(url: string): void {
      // Update the href so that it can open with right click
      eventDrivenPrepareTabs.forEach((tab) => {
        tab.href = url
      })
    }

    if (eventDrivenPrepareTabs.length > 0) {
      window.eventHub.$on('prepare-tab-url-updated', updatePrepareTabUrl)
      unsubscribers.push(() => {
        window.eventHub.$off('prepare-tab-url-updated', updatePrepareTabUrl)
      })
    }
  })
}
